export default __webpack_public_path__ + "static/media/Membership_Icon.9f48c80e.svg";